import React from 'react';
import TableHeader from './TableHeader.mjs';
import TableRow from './TableRow.mjs';

export default function GamesTable({ data }) {
  const lastUpdated = new Date(data[0].updated_at);
  const lastUpdatedString = lastUpdated.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  });

  return (
    <section aria-labelledby="games-heading" className="vstack gap-3">
      <h3 id="games-heading" className="h2 mb-0 text-primary">
        Live Games & Waiting Lists
      </h3>

      <div className="bg-white p-3 rounded">
        <table className='table table-responsive table-bordered m-0' style={{'--bs-table-bg': 'transparent'}}>
          <TableHeader />
          <tbody>
            {data.map((game) => (
              <TableRow key={game.id} {...game} />
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center fs-lg fw-normal">
        <p>Download the <a href="https://www.pokeratlas.com/info/mobile" rel="noindex nofollow" target='_blank'>Poker Atlas App</a> to check the action from anywhere.</p>
        <small>Last updated {lastUpdatedString}</small>
      </div>
    </section>
  )
}
